import { render, staticRenderFns } from "./orderDIFOTResultsChartWidget.vue?vue&type=template&id=f14b2a5e&"
import script from "./orderDIFOTResultsChartWidget.vue?vue&type=script&lang=js&"
export * from "./orderDIFOTResultsChartWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports